import { GenIcon } from 'react-icons';
export const MdCurrencyFlagHuf = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_30710)' },
            child: [
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.3156 16C23.0688 16.6978 22.7558 17.3692 22.3897 18.0007C20.3126 21.5828 16.4315 24 12.0013 24C7.57113 24 3.69002 21.5828 1.61287 18.0007C1.24678 17.3665 0.933756 16.6978 0.689697 16H23.3182H23.3156Z',
                        fill: '#029041',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M24 12.0013C24 13.4023 23.7612 14.7502 23.3156 16.0026H0.687037C0.241365 14.7502 0 13.4023 0 12.0013C0 10.6003 0.238712 9.25241 0.687037 8H23.3156C23.7612 9.25241 24 10.6003 24 12.0013Z',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.3155 8.00001H0.687012C0.931071 7.30217 1.2441 6.63085 1.61019 6.00199C3.68734 2.41725 7.56579 0 11.9986 0C16.4315 0 20.3099 2.41725 22.387 6.00199C22.7531 6.6335 23.0662 7.30217 23.3129 8.00001H23.3155Z',
                        fill: '#DB1300',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12 0.5C18.3512 0.5 23.4999 5.64869 23.5 12C23.5 18.3514 18.3513 23.501 12 23.501C5.64874 23.501 0.5 18.3514 0.5 12C0.500145 5.64869 5.64883 0.5 12 0.5Z',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_30710' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
